import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6222d527"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer load-hidden" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Made with ❤️ by Mackenzie Boudreau", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" Theme based on "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://www.buymeacoffee.com/bedimcode/e/65191"
  }, " bedimcode"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, _hoisted_4))
}